import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.png';
import InfoJumb2 from './images/infoJumbo2.png';
import InfoJumb3 from './images/infoJumbo3.png';

import banner1 from './images/banner1.png';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class gresselMain extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>GRESSEL</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="GRESSEL Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>GRESSEL</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="GRESSEL Spannsysteme"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="GRESSEL Spannsysteme"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="GRESSEL Spannsysteme"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>Das typisch mittelständische Unternehmen GRESSEL AG, CH-8355 Aadorf, wurde im Jahre 1923 als mechanische Werkstätte gegründet. 1933 entstand der erste Werkbank-Schraubstock und begründete eine Erfolgsstory. Mit dem 1965 lancierten Hochdruckspanner gelang der Zugang zur industriellen Fertigung und in der Folge sorgte das Unternehmen in der Branche "spanntechnisch" immer wieder für Furore. Seit Mitte 2014 gehört die GRESSEL AG zur SCHUNK GmbH & Co. KG aus Lauffen/Neckar. SCHUNK ist Kompetenzführer für Greifsysteme und Spanntechnik. Über 2.700 Mitarbeiter in acht Werken und 30 eigenen Ländergesellschaften gewährleisten eine intensive Marktpräsenz. Mit über 11.000 Standardkomponenten bietet SCHUNK das weltweit größte Greifsysteme- und Spanntechnik-Sortiment aus einer Hand. Seit 2012 ist die Torwartlegende Jens Lehmann Markenbotschafter für sicheres, präzises Greifen und Halten.</h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Das typisch mittelständische Unternehmen GRESSEL AG, CH-8355 Aadorf, wurde im Jahre 1923 als mechanische Werkstätte gegründet. 1933 entstand der erste Werkbank-Schraubstock und begründete eine Erfolgsstory.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.gressel.ch" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
          <section>
          <div className="supMainKeyWords White">
            <br/>
            <Grid>
              <Row>

              </Row>
              <br/>
              <Row className="show-grid">


              </Row>
            </Grid>
            <br/>
          </div>
          <br/>
        </section>

        </div>
    );
  }
}

export default gresselMain;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/gressel/mainPageSup.js